import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const loginWithOtpPageK = {
  sentOneTimeCodeTo: "login_with_otp_page.sentOneTimeCodeTo",
  sendCodeAgain: "login_with_otp_page.sendCodeAgain",
  yourProfileHasBeenCreated: "login_with_otp_page.yourProfileHasBeenCreated",
  oneTimeCode: "login_with_otp_page.oneTimeCode",
  youCanNowLoginToProfile: "login_with_otp_page.youCanNowLoginToProfile",
  otpSentSuccessfullyCheckEmail: "login_with_otp_page.otpSentSuccessfullyCheckEmail",
};

export const useLoginWithOtpPageT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      sentOneTimeCodeTo: (email: string) => t(loginWithOtpPageK.sentOneTimeCodeTo, { email }),
      sendCodeAgain: t(loginWithOtpPageK.sendCodeAgain),
      yourProfileHasBeenCreated: t(loginWithOtpPageK.yourProfileHasBeenCreated),
      oneTimeCode: t(loginWithOtpPageK.oneTimeCode),
      youCanNowLoginToProfile: t(loginWithOtpPageK.youCanNowLoginToProfile),
      otpSentSuccessfullyCheckEmail: t(loginWithOtpPageK.otpSentSuccessfullyCheckEmail),
    }),
    [i18n.language]
  );
};